module.exports = __webpack_public_path__ + "img/Novembro_Azul_630x200.69c295b1.jpg";